'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.columnSort = exports.columnSortFn = exports.columnElementsSort = exports.naturalReadingSort = exports.getIndexOfClosestCluster = undefined;

var _point = require('./geometry/point');

var pointLib = _interopRequireWildcard(_point);

var _line = require('./geometry/line');

var lineLib = _interopRequireWildcard(_line);

var _cluster = require('./structures/cluster');

var clustersLib = _interopRequireWildcard(_cluster);

var _dendrogram = require('./structures/dendrogram');

var dendrogramLib = _interopRequireWildcard(_dendrogram);

var _documentOrderAlgorithmConstants = require('./documentOrderAlgorithmConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
                                                                                                                                                                                                     * Functions responsible for sorting clusters.
                                                                                                                                                                                                     */

// Utils


// Constants


/**
 * Finds the closest cluster to a set of points.
 */
var getIndexOfClosestCluster = exports.getIndexOfClosestCluster = function getIndexOfClosestCluster(clusters, fromPoints, pointSelectionFn) {
    return clusters.reduce(function (acc, cluster, index) {
        var toPoint = pointSelectionFn(cluster);

        fromPoints.forEach(function (fromPoint) {
            var distanceModifier = fromPoint.distanceModifier || 1;
            var dist = pointLib.getDistance(fromPoint, toPoint) * distanceModifier;
            if (dist < acc.minDist) {
                acc.minDist = dist;
                acc.clusterIndex = index;
                acc.closestLine = lineLib.getLine(fromPoint, toPoint);
            }
        });

        return acc;
    }, { minDist: Infinity, clusterIndex: null, closestLine: null });
};

var sortClusters = function sortClusters(clusters, startingPoint) {
    var pointsToReadFrom = [startingPoint];
    var clustersToBeRead = [].concat(_toConsumableArray(clusters));

    var sortedClusters = [];
    // For debugging purposes
    var readingLines = [];

    var closestClusterDetails = getIndexOfClosestCluster(clustersToBeRead, pointsToReadFrom, clustersLib.getAverageTopLeft);

    while (closestClusterDetails.clusterIndex !== null) {
        // Remove the cluster we just read
        var clusterToReadNext = clustersToBeRead.splice(closestClusterDetails.clusterIndex, 1)[0];
        sortedClusters.push(clusterToReadNext);

        readingLines.push(closestClusterDetails.closestLine);

        // Make the next points to read the top right and bottom left points of the added cluster
        var clusterBottomLeftPoint = clustersLib.getAverageBottomLeft(clusterToReadNext);
        var clusterTopRightPoint = clustersLib.getAverageTopRight(clusterToReadNext);
        clusterTopRightPoint.distanceModifier = _documentOrderAlgorithmConstants.ELEMENT_TOP_RIGHT_READING_MODIFIER;

        pointsToReadFrom = [clusterBottomLeftPoint, clusterTopRightPoint];
        closestClusterDetails = getIndexOfClosestCluster(clustersToBeRead, pointsToReadFrom, clustersLib.getAverageTopLeft);
    }

    return {
        sortedClusters: sortedClusters,
        readingLines: readingLines
    };
};

/**
 * Sorts clusters based on a natural reading order.
 */
var naturalReadingSort = exports.naturalReadingSort = function naturalReadingSort(clusters) {
    // Start reading from the top of the canvas
    var canvasTopLeft = pointLib.getPoint(0, 0);
    return sortClusters(clusters, canvasTopLeft);
};

var columnElementsSort = exports.columnElementsSort = function columnElementsSort(columnCluster) {
    var clustersToBeRead = dendrogramLib.getLeafClusters(columnCluster);
    // Start reading from the column top left
    var columnTopLeft = clustersLib.getAbsoluteTopLeft(columnCluster);
    return sortClusters(clustersToBeRead, columnTopLeft);
};

var columnSortFn = exports.columnSortFn = function columnSortFn(columnA, columnB) {
    return clustersLib.getAbsoluteCenterLeft(columnA).x - clustersLib.getAbsoluteCenterLeft(columnB).x;
};

var columnSort = exports.columnSort = function columnSort(columnClusters) {
    var sortedClusters = columnClusters.sort(columnSortFn);
    var readingData = sortedClusters.reduce(function (lineData, cluster) {
        var toPoint = clustersLib.getAbsoluteTopLeft(cluster);
        if (lineData.fromPoint) {
            var line = lineLib.getLine(lineData.fromPoint, toPoint);
            lineData.lines.push(line);
        }
        lineData.fromPoint = toPoint;
        return lineData;
    }, { fromPoint: null, lines: [] });

    return {
        sortedClusters: sortedClusters,
        readingLines: readingData.lines
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/documentOrder/clusterSorter.js
// module id = 2259
// module chunks = 0